// Wrapper Gmail del drawer mail condiviso: applica il context del provider
// Google e calcola il gate provider-specifico (google_workspace_enabled &&
// sync_gmail). Montato in Layout.tsx. Il componente condiviso e` <MailDrawer>.
import React, { useEffect } from 'react';
import { useSettingsStore } from '../../lib/stores/settingsStore';
import { useGmailDrawerStore } from '../../lib/stores/gmailDrawerStore';
import { useOutlookDrawerStore } from '../../lib/stores/outlookDrawerStore';
import { MailProviderContext } from './MailProviderContext';
import { googleMailProvider } from './providers';
import { MailDrawer } from './MailDrawer';

export function GmailDrawer() {
  const { settings } = useSettingsStore();
  const enabled = !!(settings?.google_workspace_enabled && settings?.sync_gmail);
  const isOpen = useGmailDrawerStore((s) => s.isOpen);

  // Mutua esclusione coi drawer Outlook: entrambi i drawer condividono la stessa
  // area/z-index e la gestione dello scroll del body — mai due aperti insieme.
  useEffect(() => {
    if (isOpen) useOutlookDrawerStore.getState().close();
  }, [isOpen]);

  return (
    <MailProviderContext.Provider value={googleMailProvider}>
      <MailDrawer enabled={enabled} />
    </MailProviderContext.Provider>
  );
}
